module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5c6ee7ea907b1335ebf5b032296efd54.png";